import { useEntryValuesStore } from "@/features/inputs/hooks/useEntryValuesStore";
import type { InputT } from "@patient-watch/types";
import { RichLabel } from "@patient-watch/forms";

import { cn } from "../../lib/utils";
import { ui } from "@patient-watch/ui";

interface Props {
    input: InputT;
}
const ScaleRating = ({ input }: Props) => {
    const entryValue = useEntryValuesStore((state) => state.getEntryValueByInputId(input.input_id));
    const upsertEntryValue = useEntryValuesStore((state) => state.upsertEntryValue);

    const handleOptionChange = (value: number, label: string) => {
        upsertEntryValue({
            ...entryValue,
            input_id: input.input_id,
            number_value: value,
            text_value: label,
        });
    };

    return (
        <ui.Card>
            <ui.CardHeader>
                <ui.Label>
                    <RichLabel>{input.input_label}</RichLabel>
                </ui.Label>
            </ui.CardHeader>
            <ui.CardContent>
                <ul className="flex flex-row overflow-x-scroll">
                    {[...input.scale_options]
                        .sort((a: any, b: any) => {
                            // Sort highest to lowest
                            const aValue = a.value === "" ? -Infinity : Number(a.value);
                            const bValue = b.value === "" ? -Infinity : Number(b.value);
                            return bValue - aValue;
                        })
                        .map((option: any) => (
                            <li key={`scale-rating-${option.value}`} className="flex flex-col">
                                <button
                                    type="button"
                                    key={option.value}
                                    onClick={() => handleOptionChange(option.value, option.label)}
                                    className={cn(
                                        "m-1 px-4 py-2 rounded-md text-white text-lg transition-all duration-300 ease-in-out",
                                        entryValue?.number_value === option.value ? "bg-indigo-600" : "bg-slate-300"
                                    )}
                                >
                                    {option.value}
                                </button>
                                <p className="ml-1 w-8 overflow-x-show text-slate-600 text-center">{option.label}</p>
                            </li>
                        ))}
                </ul>
            </ui.CardContent>
        </ui.Card>
    );
};

export default ScaleRating;
